import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import {
  User,
  whoAmI,
  login as loginApiCall,
  logout as logoutApiCall,
} from '../apiClient/auth';

type AuthState = {
  user: User | null;
  whoAmILoading: boolean;
};

export const authAtom = atom<AuthState>({
  user: null,
  whoAmILoading: true,
});

export function useAuth() {
  const [authState, setAuth] = useAtom(authAtom);

  useEffect(() => {
    (async () => {
      try {
        const response = await whoAmI();
        setAuth({ user: response.user, whoAmILoading: false });
      } catch {
        setAuth({ user: null, whoAmILoading: false });
      }
    })();
  }, []);

  async function login(emailOrUsername: string, password: string) {
    try {
      const response = await loginApiCall({
        username: emailOrUsername,
        password: password,
      });
      setAuth({ user: response.user, whoAmILoading: false });
    } catch {
      setAuth({ user: null, whoAmILoading: false });
      throw new Error('Login failled');
    }
  }

  async function logout() {
    await logoutApiCall();
    setAuth({ user: null, whoAmILoading: false });
  }

  return { authState, login, logout };
}
